<!--
수동등록 > 상품 이미지업로드 컴포넌트
-->
<template>
    <!-- 폼 화면 -->
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4 class="uk-text-center">이미지파일 업로드</h4>
            </div>

            <div class="uk-modal-body">

                <div class="uk-flex uk-flex-between uk-flex-middle">
                    <!-- 업로드 이미지 표시 -->
                    <div class="uploaded-image">
                        <img
                            v-show="uploaded.is_img === 1"
                            :src="uploaded.url"
                        />

                        <!-- 파일명 -->
                        <div class="file-name" :title="uploaded.name">
                            {{ uploaded.name }}
                        </div>
                    </div>

                    <!-- 업로드 영역 -->
                    <div class="uk-width-expand">
                        <form action="/files" class="upload-area">
                            <input type="hidden" name="_token" :value="csrfToken"/>
                            <input type="hidden" name="type" value="99"/>
                            <input v-if="tempId" type="hidden" name="temp_id" :value="tempId"/>


                            <!-- javascript 미지원시 fallback 처리 -->
                            <div class="fallback">
                                <input name="file" type="file" multiple />
                            </div>

                            <!-- 업로드 안내 메세지 -->
                            <div class="dz-message needsclick">
                                <i class="material-icons uk-text-middle">
                                    cloud_upload
                                </i>
                                업로드할 이미지파일을 선택하거나, 드래그 하세요
                            </div>
                        </form>
                    </div>

                </div>



            </div>


            <div class="uk-modal-footer uk-text-right">

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                    :disabled="! submitReady"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>

</template>

<script>
    // dropzone
    import * as Dropzone from '../../../../dropzone/dist/dropzone-amd-module.js';
    Dropzone.autoDiscover = false;

    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // (bool) 초기화여부
                initialized: false,

                // 임시파일ID
                tempId: null,

                // 업로드된 이미지
                uploaded: {},
            };
        },
        computed: {
            /**
             * 서브밋 준비가 완료되었는지 여부
             * @return bool
             */
            submitReady() {
                return Boolean(this.uploaded.id);
            },
        },

        methods: {
            /**
             * 임시ID 조회
             * @return Promise
             */
            loadTempId() {
                // promise 생성
                return new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/file-temp-id',
                        data: {
                            //'_token': this.csrfToken,
                        },
                        success: (response, textStatus, jqXHR) => {
                            this.tempId = response.temp_id;
                            // promise 성공
                            resolve(response);
                        },
                        error: (jqXHR, textStatus, errorThrown) => {
                            alert('초기화(임시ID조회 실패) 도중 문제가 발생했습니다. 새로고침 후 다시 시도하세요');
                            // promise 실패
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });

            },

            /**
             * 입력폼 display
             */
            displayForm() {

                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             */
            form() {
                // 초기화
                if (! this.initialized) {
                    this.init();
                }

                this.uploaded = {};
                this.displayForm();
            },

            /**
             * 초기화 작업
             */
            init() {
                // 폼 엘리먼트
                let form = this.$el.querySelectorAll('.upload-area')[0];

                // Dropzone 생성
                this.myDropzone = new Dropzone(form, {
                    maxFilesize: 10, // MB
                });
                //console.log(myDropzone);
                form.classList.add("dropzone");

                // dropzone 이벤트 리스닝
                let myDropzone = this.myDropzone;
                myDropzone.on("success", (file, response) => {
                    this.uploaded = response.uploaded;
                    //console.log(response.uploaded);

                    // dropzone 업로드 영역에서 제거
                    myDropzone.removeFile(file);
                });

                // 임시ID 조회
                this.loadTempId().then((response) => {
                    //alert('준비가 완료되었습니다');

                    // 초기화 완료
                    this.initialized = true;
                });



            },


            /**
             * submit
             */
            submit() {
                if (! this.uploaded.id) {
                    alert('이미지를 업로드 하세요');
                    return;
                }

                this.$emit('uploaded', this.uploaded);
                UIkit.modal(this.$el).hide();

            },
        },


    }
</script>

<style lang="scss" scoped>
    .uploaded-image {
        width: 150px;
        margin-right: 20px;

        img {
            width: 150px;
        }

        // 파일명
        .file-name {
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .dropzone{
        border: 1px dashed #0087F7;
        min-height: 100px;

        .dz-message {
            font-size: 1rem;
        }
    }
</style>